

































import { Component, Prop } from 'vue-property-decorator';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';
import ConversationStatus from '@/models/Conversations/ConversationStatus';
import UpdateConversationStatusRequest from '@/models/Conversations/UpdateConversationStatusRequest';
import ConversationDto from '@/models/Conversations/ConversationDto';
import { BookingDetailsModule } from '@/store/modules/bookingDetails';
import ListUtils from '@/lib/listUtils';

@Component({
    name: 'BookingConversationStatusEdit'
})
export default class extends GiganautVueDialog {
 
	conversationStatus = ConversationStatus;

	@Prop({required: true})
  conversation: ConversationDto

  async setStatus(status: ConversationStatus) {
    const conversation = JSON.parse(JSON.stringify(BookingDetailsModule.conversation));
    if (conversation.status !== status) {
      const request = new UpdateConversationStatusRequest();
      request.status = status;
      await BookingDetailsModule.editConversationStatus(request);
    }
  }
}
